import React from 'react';
import PropTypes from 'prop-types';


class BaseStepContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { children } = this.props;

        return children;
    }
}

BaseStepContent.propTypes = {
    children: PropTypes.node.isRequired,
};

export default BaseStepContent;
